<template>
  <div>
    <card
      class="player-card"
      :bodyClasses="['body', {'closed': !expanded}]"
      shadow
    >
      <div slot="header" class="row d-flex align-items-center">
        <div
          class="col-auto d-flex align-items-center"
          @click="expand"
          v-if="model && model.avatar"
        >
          <a href="#!" class="avatar rounded-circle">
            <img alt="Image placeholder" :src="getAvatarUrl(model)">
          </a>
        </div>
        <div class="col name" @click="expand">
          {{model.Name !== "" ? model.Name : 'New Player'}}
        </div>
        <div class="col d-flex justify-content-end">
          <PaymentToggle v-model="model.paidInFull" :error="errors.paidInFull"/>
        </div>
        <div class="col-auto text-right d-flex align-items-center justify-content-end">
          <i class="fa fa-trash delete-icon" @click="$emit('onRemove')"/>
          <i
            class="fa fa-chevron-down expand-icon"
            v-if="!expanded"
            @click="expand"
          />
          <i
            class="fa fa-chevron-up expand-icon"
            v-else-if="expanded"
            @click="expand"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-12" v-if="model.id === ''">
          <base-input
            alternative=""
            label="Name"
            placeholder="Name"
            input-classes="form-control-alternative"
            v-model="model.Name"
            :error="errors.Name"
          />
        </div>
        <div class="col-12"  v-if="model.id === ''">
          <base-input
            alternative=""
            label="Email"
            placeholder="Email"
            input-classes="form-control-alternative"
            v-model="model.email"
            type="email"
            :error="errors.email"
          />
        </div>
        <div class="col-12" v-if="model.id === ''">
          <base-input
            alternative=""
            label="Avatar Image"
            input-classes="form-control-alternative"
            type="file"
            @change="handleFileUpload"
          />
        </div>
        <div class="col-12 last-row">
          <label :class="['form-control-label']">
            Toonie Pot
          </label><br />
          <base-switch v-model="model.tooniePot"></base-switch>
        </div>
      </div>

    </card>
  </div>
</template>
<script>
import AvatarHelper from '@/helpers/Avatars.js';
import PaymentToggle from '@/components/PaymentToggle.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'TeamPlayerCard',
  components: {
    PaymentToggle,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      expanded: false,
      file: null,
    };
  },
  computed: {
    model: {
      get() {
        console.log(this.value);
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    hasError() {
      if (Object.keys(this.errors) > 0) {
        return true;
      }
      return false;
    },
    errors() {
      const errorObject = {};
      console.log('PAID IN FULL', this.model);
      if (this.model.id === '' && this.model.Name === '') {
        errorObject.Name = 'Name is required';
      }
      if (this.model.id === '' && this.model.email === '') {
        errorObject.email = 'Email is required';
      }
      if (this.model.paidInFull === '') {
        errorObject.paidInFull = 'Required';
      }
      return errorObject;
    },
  },
  mounted() {
    if (this.value.id === '') {
      this.expanded = true;
    }
  },
  methods: {
    expand() {
      this.expanded = !this.expanded;
    },
    getAvatarUrl(user) {
      console.log(user);
      return AvatarHelper.getAvatar(user);
    },
    handleFileUpload(e) {
      const files = e.target.files || e.dataTransfer.files;

      if (files.length > 0) {
        const [firstFile] = files;
        this.file = firstFile;
      }

      if (this.file !== null) {
        this.uploadImage()
          .then((response) => {
            this.model.avatar = response.data[0];
          })
          .catch((error) => {
            ErrorHandler.handleError(error);
          });
      }
    },
    uploadImage() {
      const formData = new FormData();
      formData.append('files', this.file);

      return this.axios
        .post('/upload', formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        });
    },
  },

};
</script>
<style lang="scss" scoped>
  .col {
    font-size: .9rem;
  }
  .expand-icon {
    margin-left: 1rem;
    cursor: pointer;
  }
  .name{
    font-weight: bold;
  }
  .delete-icon{
    transition: all .25s;
    cursor: pointer;

    &:hover{
      color: #f5365c;
    }
  }
  .avatar {
    width: 35px;
    height: 35px;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
<style lang="scss">
  .body{
    transition: all .15s;
  }
  .closed{
    height: 0;
    opacity: 0;
    visibility: none;
    padding: 0;
  }
  .player-card{
    overflow: hidden;
    .card-header{
      padding: .75rem 1.5rem .75rem .75rem;
    }
  }

  .last-row .form-group{
    margin-bottom: 0;
  }
</style>
